import { render, staticRenderFns } from "./radio-item.vue?vue&type=template&id=5b99ad0b&scoped=true&lang=pug&"
import script from "./radio-item.vue?vue&type=script&lang=coffee&"
export * from "./radio-item.vue?vue&type=script&lang=coffee&"
import style0 from "./radio-item.vue?vue&type=style&index=0&id=5b99ad0b&lang=stylus&scoped=true&"
import style1 from "./radio-item.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99ad0b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormPdpSubscriptionIntervalSelector: require('/opt/build/repo/library/components/globals/form/pdp-subscription-interval-selector.vue').default})
